<template>
  <div class="notfound">
    <h1>{{ $t('notFound.title') }}</h1>
    <p>{{ $t('notFound.content') }}</p>
  </div>
</template>

<script>
import localeHandler from './mixins/localeHandler'

export default {
  name: 'notFound',
  mixins: [ localeHandler ],
  beforeRouteEnter (to, from, next) {
    next(vm => {
      vm.$emit('loaded')
    })
  }
}
</script>
